
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'FlatStepper',
  components: {},
  props: {
    currentStep: {
      type: Number,
      required: true,
    },
    totalSteps: {
      type: Number,
      required: true,
    },
  },
  setup() {
    const baseClass = 'epb-flat-stepper'

    return {
      baseClass,
    }
  },
})
